module.exports = __webpack_public_path__ + "static/media/m120-43.59eb3c44.png";